import {
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { message } from 'antd';

import {
  GenericDataFormContext,
  LoadSavedQuotations,
  QUOTATION_BUTTON,
  QuotationButton,
  QuotationInfoContext,
  QuotationStep,
  StepOneFormContext,
} from '../../../../../shared';
import {
  HeaderTabCar,
  TabsPropertyDataCar,
} from '../../components/PropertyDataCar/components';

import MasterService from '../../../../../../../../../shared/services/master';
import QuotationService from '../../../../../../../../../shared/services/quotation';

import { StepTwoFormContext } from './StepTwoFormContext';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

import {
  CarAccessory,
  CarBonification,
  CardScoringQuestions,
  CarQuotationCoverage,
  CarQuotationScoring,
  CarQuotationScoringQuestion,
  CarQuotationServiceRequest,
  CarQuotationServiceResponse,
  CarReQuotationServiceRequest,
  CarReQuotationServiceResponse,
  CarTax,
  CurrencyCode,
  DECISION_TYPE,
  DecisionType,
  RemoveVehicleDataServiceRequest,
  SelectOption,
  Version,
  WebDiscountRateResponse,
} from '../../../../../../../../../shared/interfaces';
import { LOADING_SAVED_QUOTATIONS_STATES } from '../../../../../shared/interfaces/loading-saved-quotations-states-enum';

import { getValueDefaultPaymentMethod } from '../../../../../utils';
import { LOADING_RENEWAL_QUOTATION_STATES } from '../../../../../shared/interfaces/loading-renewal-quotation-states-enum';
import { LoadQuotationToRenewResponse } from '../../../../../shared/interfaces/load-renewal-quotation-response-interface';
import { QuotationArticles } from '../../../../../utils/quotation-articles.enum';
import { RequestListTextSubcategory } from '../../../../../../../../../shared/interfaces/services/request-list-text-subcategory';
import { TextSubcategory } from '../../../../../../../../../shared/interfaces/services/get-list-text-subcategory';
import { scrollToEmitButton } from '../../../../../../../../../shared/utils';

const {
  STEP_ONE_DATA_FILLED,
  STEP_TWO_SERVICES_LOADING,
  STEP_TWO_SERVICES_LOADED,
  STEP_TWO_DATA_FILLING,
  STEP_TWO_DATA_FILLED,
} = LOADING_SAVED_QUOTATIONS_STATES;

const {
  STEP_ONE_DATA_FILLED_RENEWAL,
  STEP_TWO_SERVICES_LOADING_RENEWAL,
  STEP_TWO_SERVICES_LOADED_RENEWAL,
  STEP_TWO_DATA_FILLING_RENEWAL,
  STEP_TWO_DATA_FILLED_RENEWAL,
} = LOADING_RENEWAL_QUOTATION_STATES;

export interface CarAccessoryTable {
  key: string;
  accessoryDescription: string;
  price: string;
}
export interface CarAccessoriesTable {
  [key: number | string]: Array<CarAccessoryTable>;
}

export interface CarPaymentMethodForm {
  [key: string]: string | number;
  paymentMethod: string;
  comission: number;
  extraVariable: number;
  variation: number;
}

export const StepTwoFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const INITIAL_KEY_TAB = 1;
  const newTabIndex = useRef(INITIAL_KEY_TAB);

  const { setCanShowSpinner, paymentMethodsList,setIsErrorServices,isErrorServices } = useContext(
    GenericDataFormContext
  );
  const {
    currentStep,
    loadSaveQuotationState,
    quotationInfo,
    quoatationInfoRequest,
    setQuoatationInfoRequest,
    savedQuotation,
    setCurrentStep,
    setLoadSaveQuotationState,
    renewalQuotationState,
    setRenewalQuotationState,
    quotationToRenewal
  } = useContext(QuotationInfoContext);
  const {
    articleHasScoring,
    commertialConditions,
    coverageSelectedByVehicle,
    handleTabErrors,
    quotationResponseByCar,
    removeInfoOfVehicle,
    reQuotationResponseByCar,
    selectCoveragePerVehicle,
    setQuotationResponseByCar,
    setReQuotationResponseByCar,
    stepThreeForm,
    stepTwoForm,
    versionSelectedByVehicle,
  } = useContext(WizardDataFormContext);
  const { clientSelected } = useContext(StepOneFormContext);

  const [accessoriesList, setAccessoriesList] = useState<Array<SelectOption>>(
    []
  );
  const [accessoryTable, setAccessoryTable] = useState<CarAccessoriesTable>({
    [INITIAL_KEY_TAB]: [],
  });

  const [showWebDiscountRate, setShowWebDiscountRate] = useState<
    WebDiscountRateResponse | undefined
  >();

  const [activeKey, setActiveKey] = useState<any>(INITIAL_KEY_TAB);

  const [isLoadingBrandList, setIsLoadingBrandList] = useState<boolean>(false);
  const [isLoadingModelList, setIsLoadingModelList] = useState<boolean>(false);
  const [isLoadingAccessoriesList, setIsLoadingAccessoriesList] =
    useState<boolean>(false);
  const [isLoadingVersionList, setIsLoadingVersionList] =
    useState<boolean>(false);

  const [keyTabToDelete, setKeyTabToDelete] = useState<number | null>(null);

  const [showModal, setShowModal] = useState<boolean>(false);

  const [carFormValues, setCarFormValues] = useState<any>();

  const [yearList, setYearList] = useState<Array<SelectOption>>([]);

  const [brandsByYear, setBrandsByYear] = useState<
    Array<{ year: string; brands: Array<SelectOption> }>
  >([]);

  const [modelsByBrandAndYear, setModelsByBrandAndYear] = useState<
    Array<{ brand: string; year: string; models: Array<SelectOption> }>
  >([]);

  const [versionsByYearBrandAndModel, setVersionsByYearBrandAndModel] =
    useState<
      Array<{
        brand: string;
        year: string;
        model: string;
        versionOptions: Array<SelectOption>;
        versions: Array<Version>;
      }>
    >([]);

  const [scoringQuestions, setScoringQuestions] = useState<
    Array<CardScoringQuestions>
  >([]);

  const [goodResultTypesList, setGoodResultTypesList] = useState<
    Array<SelectOption>
  >([]);

  const [labelButton, setLabelButton] = useState<QuotationButton>(
    QUOTATION_BUTTON.EMITIR
  );

  const [tabs, setTabs] = useState<any[]>([
    {
      label: <HeaderTabCar id={INITIAL_KEY_TAB} />,
      children: <TabsPropertyDataCar id={INITIAL_KEY_TAB} />,
      key: INITIAL_KEY_TAB,
      closable: false,
      forceRender: true,
    },
  ]);

  const addNewTab = useCallback(() => {
    if (tabs.length <= 5) {
      const newActiveKey = ++newTabIndex.current;

      setTabs([
        ...tabs,
        {
          label: <HeaderTabCar id={newActiveKey} />,
          children: <TabsPropertyDataCar id={newActiveKey} />,
          key: newActiveKey,
          closable: false,
          forceRender: true,
        },
      ]);

      setActiveKey(newActiveKey);

      return;
    }

    message.error('Solo puede agregar hasta 6 vehículos.');
  }, [tabs, newTabIndex, setTabs, setActiveKey]);

  const duplicateTab = useCallback(
    (id: any) => {
      if (tabs.length <= 5) {
        const tabSelected = tabs.find(
          (tab: any) => String(tab.key) === String(id)
        );
        const newActiveKey = ++newTabIndex.current;

        if (tabSelected) {
          const newTab = {
            ...tabSelected,
            key: newActiveKey,
            label: <HeaderTabCar id={newActiveKey} />,
            children: (
              <TabsPropertyDataCar id={newActiveKey} duplicateId={id} />
            ),
            closable: false,
            forceRender: true,
          };
          setTabs([...tabs, newTab]);
          setActiveKey(newActiveKey);
        }

        return;
      }

      message.error('Solo puede agregar hasta 6 vehículos.');
    },
    [tabs, newTabIndex, setTabs, setActiveKey]
  );

  const removeTab = useCallback(
    (targetKey: number) => {
      setCanShowSpinner(true);

      setTimeout(() => {
        const targetIndex = tabs.findIndex(
          (pane: any) => String(pane.key) === String(targetKey)
        );
        const newPanes = tabs.filter(
          (pane: any) => String(pane.key) !== String(targetKey)
        );

        if (newPanes.length && String(targetKey) === String(activeKey)) {
          const { key } =
            newPanes[
              targetIndex === newPanes.length ? targetIndex - 1 : targetIndex
            ];
          setActiveKey(key);
        }

        setTabs(newPanes);
        setCanShowSpinner(false);
      }, 500);
    },
    [tabs, setTabs, setActiveKey, activeKey, setCanShowSpinner]
  );

  const getYears = useCallback(async () => {
    try {
      const response = await QuotationService.getYearForCombo();
      setYearList(response);
    } catch {}
  }, [setYearList]);

  const getBrandsByYear = useCallback(
    async (year: string) => {
      if (brandsByYear.some((el) => el.year === year)) return;

      setIsLoadingBrandList(true);

      try {
        const response = await QuotationService.getBrandsByYearForCombo(year);

        if (response) {
          setBrandsByYear((prevValues) => [
            ...prevValues,
            { year, brands: response },
          ]);
        }
      } catch {
      } finally {
        setIsLoadingBrandList(false);
      }
    },
    [brandsByYear, setIsLoadingBrandList, setBrandsByYear]
  );

  const getModelByBrandAndYear = useCallback(
    async (year: string, brand: string) => {
      if (
        modelsByBrandAndYear.some(
          (el) => el.year === year && el.brand === brand
        )
      )
        return;

      setIsLoadingModelList(true);

      try {
        const response = await QuotationService.getModelByYearAndBrandCombo(
          year,
          brand
        );

        setModelsByBrandAndYear((prevValues) => [
          ...prevValues,
          { year, brand, models: response },
        ]);
      } catch {
      } finally {
        setIsLoadingModelList(false);
      }
    },
    [modelsByBrandAndYear, setIsLoadingModelList, setModelsByBrandAndYear]
  );

  const getVersionByYearBrandAndModel = useCallback(
    async (year: string, brand: string, model: string) => {
      if (
        versionsByYearBrandAndModel.find(
          (el) => el.brand === brand && el.model === model && el.year === year
        )
      )
        return;

      setIsLoadingVersionList(true);

      try {
        const response =
          await QuotationService.getVersionByYearAndMarkAndModelCombo(
            year,
            brand,
            model
          );

        const options = response.data.versiones.map((item: Version) => {
          return {
            value: item.codigoVersion,
            label: item.descripcion,
          };
        });

        setVersionsByYearBrandAndModel((prevValues) => [
          ...prevValues,
          {
            brand,
            model,
            year,
            versions: response.data.versiones,
            versionOptions: options,
          },
        ]);
      } catch {
      } finally {
        setIsLoadingVersionList(false);
      }
    },
    [
      setIsLoadingVersionList,
      versionsByYearBrandAndModel,
      setVersionsByYearBrandAndModel,
    ]
  );

  const getCarAccessoriesList = useCallback(async () => {
    setIsLoadingAccessoriesList(true);

    try {
      const response = await QuotationService.getCarAccessoriesList();

      setAccessoriesList(response);
    } catch {
    } finally {
      setIsLoadingAccessoriesList(false);
    }
  }, [setIsLoadingAccessoriesList, setAccessoriesList]);

  const getWebDiscountRate = useCallback(async () => {
    try {
      const response = await QuotationService.getWebDiscountRate({
        rama: quotationInfo?.branch!,
        numeroCotizacion: quotationInfo?.token!,
      });
      setShowWebDiscountRate(response.data);
    } catch (error) {}
  }, [quotationInfo, setShowWebDiscountRate]);

  const getScoringQuestions = useCallback(async () => {
    try {
      const response = await QuotationService.getCarScoringQuestions();
      if (response?.data) {
        setScoringQuestions(response.data.preguntas);
      }
    } catch {
      message.error(
        'Ha ocurrido un error al intentar obtener las preguntas. Por favor intente más tarde.'
      );
    }
  }, [setScoringQuestions]);

  const getGoodResultList = useCallback(async () => {
    try {
      const response = await MasterService.getGoodResultTypesList();
      if (response) {
        setGoodResultTypesList(response);
      }
    } catch {}
  }, [setGoodResultTypesList]);

  const getInitialInfo = useCallback(async () => {
    const promises: Array<Promise<void>> = [];

    if (!yearList.length) promises.push(getYears());
    if (!accessoriesList.length) promises.push(getCarAccessoriesList());
    if (!showWebDiscountRate) promises.push(getWebDiscountRate());
    if (articleHasScoring && !scoringQuestions.length)
      promises.push(getScoringQuestions());
    if (!goodResultTypesList.length) promises.push(getGoodResultList());

    if (!promises.length) return;

    await Promise.all(promises);
  }, [
    yearList,
    accessoriesList,
    getYears,
    getCarAccessoriesList,
    showWebDiscountRate,
    getWebDiscountRate,
    scoringQuestions,
    getScoringQuestions,
    goodResultTypesList,
    getGoodResultList,
    articleHasScoring,
  ]);

  const generateTitleForTabs = useCallback(
    (
      yearSelected: string,
      brandSelected: string,
      modelSelected: string
    ): string | undefined => {
      const brand = brandsByYear
        ?.find((el) => el.year === yearSelected)
        ?.brands.find((el) => el.value === brandSelected)?.label;

      const year = yearList.find((el) => el.value === yearSelected)?.label;

      const model = modelsByBrandAndYear
        .find((el) => el.brand === brandSelected && el.year === yearSelected)
        ?.models.find((el) => el.value === modelSelected)?.label;

      if (brand && year && model) {
        return `${brand} ${model} ${year}`;
      }
    },
    [brandsByYear, yearList, modelsByBrandAndYear]
  );

  const getAccesoriesOfVehicle = useCallback(
    (componentId: string): Array<CarAccessory> => {
      const tableAccessories: Array<CarAccessoryTable> =
        accessoryTable[componentId] ?? [];

      return tableAccessories.map(({ accessoryDescription, price }, index) => ({
        accesorioNombre: accessoryDescription,
        accesorioValor: price,
        accesorioTipo: '',
        accesorioSecuencia: index + 1,
      }));
    },
    [accessoryTable]
  );

  const getScoringOfVehicle = useCallback(
    (componentId: string): CarQuotationScoring => {
      const questions: Array<CarQuotationScoringQuestion> =
        scoringQuestions.map(({ codigo }) => ({
          codigoItem: codigo,
          respuesta: stepTwoForm?.getFieldValue(`${codigo}-tab-${componentId}`) === DECISION_TYPE.YES ? 'V' : 'F',
          cantidad: 0,
        }));

      return {
        codigoTabla: componentId,
        preguntas: questions,
      };
    },
    [scoringQuestions, stepTwoForm]
  );

  const getVersionVehicleInfo = useCallback(
    (year: string, brand: string, model: string, version: string) => {
      const versions = versionsByYearBrandAndModel.find(
        (el) =>
          String(el.brand) === String(brand) &&
          String(el.model) === String(model) &&
          String(el.year) === String(year)
      )?.versions;

      const specificVersion = versions?.find(
        (el) => String(el.codigoVersion) === String(version)
      );
      return specificVersion;
    },
    [versionsByYearBrandAndModel]
  );

  const generateCarQuotationForm = useCallback(
    (componentId: string): CarQuotationServiceRequest => {

      const gncRadioFieldName = `gnc-tab-${componentId}`;
      const hasGNC: DecisionType =
        stepTwoForm?.getFieldValue(gncRadioFieldName);
      
      const gncValueFieldName = `gncValue-tab-${componentId}`;
      const gncValue: string = stepTwoForm?.getFieldValue(gncValueFieldName);

      const yearFieldName = `vehicleYear-tab-${componentId}`;
      const vehicleYear: string = stepTwoForm?.getFieldValue(yearFieldName);

      const brandFieldName = `brand-tab-${componentId}`;
      const brand: string = stepTwoForm?.getFieldValue(brandFieldName);

      const modelFieldName = `model-tab-${componentId}`;
      const model: string = stepTwoForm?.getFieldValue(modelFieldName);

      const versionFieldName = `version-tab-${componentId}`;
      const version: string = stepTwoForm?.getFieldValue(versionFieldName);

      const vehicleInfo = getVersionVehicleInfo(
        vehicleYear,
        brand,
        model,
        version
      );

      const locationFieldName = `location-tab-${componentId}`;
      
      const location = stepTwoForm?.getFieldValue(locationFieldName);

      const zoneFieldName = `zone-tab-${componentId}`;
      const zone: string = stepTwoForm?.getFieldValue(zoneFieldName);
      
      const postalCodeSufix = location.value ? location.value.slice(0,1) : location.slice(0,1);
      const postalCode = location.value ? location.value.slice(1) : location.slice(1);
      
      const carInfoValueFieldName = `infoValueCar-tab-${componentId}`;
      const carInfoValue: string = stepTwoForm?.getFieldValue(
        carInfoValueFieldName
      );

      const isIntegralClientFieldName = `integralClient-tab-${componentId}`;
      const isIntegralClient: DecisionType = stepTwoForm?.getFieldValue(
        isIntegralClientFieldName
      );

      const goodResultFieldName = `goodResult-tab-${componentId}`;
      const goodResult: string =
        stepTwoForm?.getFieldValue(goodResultFieldName);

      const paymentMethodFormCode = stepThreeForm?.getFieldInstance(
        `paymentMethod`
      )
        ? (stepThreeForm?.getFieldValue(`paymentMethod`) as string).split(
            '-'
          )[1]
        : getValueDefaultPaymentMethod(paymentMethodsList);

      const specialDisccountFieldName = `webDiscount-tab-${componentId}`;

      const specialDisccount: string = stepTwoForm?.getFieldValue(
        specialDisccountFieldName
      );

      const accessories = getAccesoriesOfVehicle(componentId);

      let scoring: CarQuotationScoring | undefined;

      const shouldUseScoring =
        (articleHasScoring || quotationToRenewal?.tieneScoring === DECISION_TYPE.YES || savedQuotation?.tieneScoring === DECISION_TYPE.YES);

      if (shouldUseScoring) {
        scoring = getScoringOfVehicle(componentId);
      }


      const gnc = gncValue ?? 0;
      const totalValor = accessories.reduce(
        (sum, item: any) => sum + item.accesorioValor,
        0
      );
      const valueInsurance =
        Number(carInfoValue) + Number(gnc) + Number(totalValor);
      
      const params: CarQuotationServiceRequest = {
        token: quotationInfo?.token!,
        arse: quotationInfo?.arse!,
        rama: quotationInfo?.branch!,
        codigoTipoFormaPago: paymentMethodFormCode,
        cliente: clientSelected!,
        componente: componentId,
        anio: vehicleYear,
        codigoMarcaGaus: vehicleInfo?.codigoMarcaGaus!,
        codigoModeloGaus: vehicleInfo?.codigoModeloGaus!,
        codigoVersionGaus: vehicleInfo?.codigoVersionGaus!,
        valorAsegurado: String(valueInsurance),
        gnc: hasGNC,
        valorGnc: gnc,
        codigoPostal: postalCode,
        sufijoCodigoPostal: postalCodeSufix,
        zonaRiesgoAuto: zone,
        clienteIntegral: isIntegralClient,
        buenResultado: goodResult ?? 0,
        descuentoEspecial: specialDisccount ?? 0,
        codigoTarifa: '0', //* Para las cotizaciones es 0.
        accesorios: accessories,
        scoring,
      };

      setQuoatationInfoRequest(params);

      return params;
    },
    [
      articleHasScoring,
      clientSelected,
      getScoringOfVehicle,
      quotationInfo,
      stepTwoForm,
      getValueDefaultPaymentMethod,
      paymentMethodsList,
      getAccesoriesOfVehicle,
      stepThreeForm,
      getVersionVehicleInfo,
    ]
  );

  const getQuotationInfoPerVehicle = useCallback(
    (componentId: string) => {
      const quotationResponse = quotationResponseByCar.find(
        (el) => String(el.componentId) === String(componentId)
      )?.quotationResponse;

      return quotationResponse;
    },
    [quotationResponseByCar]
  );

  const getBonifications = useCallback(
    (quotationInfo: CarQuotationServiceResponse): Array<CarBonification> => {
      const bonifications: Array<CarBonification> = [];

      quotationInfo?.coberturas?.forEach((coverage) => {
        coverage?.bonificaciones?.forEach(
          ({ codigo, descripcion, porcentajeAplicado }) => {
            const bonification: CarBonification = {
              codigoCobertura: coverage?.codigo,
              codigo,
              descripcion,
              porcentaje: porcentajeAplicado,
              porcentajeMinimo: '',
              porcentajeMaximo: '',
              modificable: false,
            };

            bonifications.push(bonification);
          }
        );
      });      
      return bonifications;
    },
    []
  );

  const getEPVAndCommisionValue = useCallback(
    (componentId: string, coverage: CarQuotationCoverage) => {
      const coverageSelected = coverageSelectedByVehicle?.find(
        (el) => String(el.componentId) === String(componentId)
      )?.coverageSelected;

      const commissionValue = stepThreeForm?.getFieldValue(`commission`);
      const extraVariableValue = stepThreeForm?.getFieldValue(`extraVariable`);

      const porcentajeComision = (commissionValue !== undefined && commissionValue !== null && commissionValue !== '')
        ? String(commissionValue)
        : String(commertialConditions?.porcentajeDeComision || 0);

      const porcentajeExtraPrima = (extraVariableValue !== undefined && extraVariableValue !== null && extraVariableValue !== '')
        ? String(extraVariableValue)
        : String(commertialConditions?.porcentajeExtraPrimaVariable || 0);

      return {
        porcentajeComision,
        porcentajeExtraPrima,
      };
    },
    [coverageSelectedByVehicle, stepThreeForm, commertialConditions, activeKey]
  );

  const getTaxes = useCallback(
    (
      quotationInfo: CarQuotationServiceResponse | null | undefined,
      componentId: string
    ): Array<CarTax> => {
      const taxes: Array<CarTax> = [];

      if (quotationInfo?.coberturas) {
        quotationInfo.coberturas.forEach((coverage) => {
          const { porcentajeComision, porcentajeExtraPrima } =
            getEPVAndCommisionValue(componentId, coverage);

          const tax: CarTax = {
            codigoCobertura: coverage.codigo,
            porcentajeComision,
            porcentajeExtraPrima,
          };

          taxes.push(tax);
        });
      } else {
        const coverageSelected = coverageSelectedByVehicle.find(
          (el) => String(el.componentId) === String(componentId)
        )?.coverageSelected;

        if (coverageSelected) {
          const { porcentajeComision, porcentajeExtraPrima } =
            getEPVAndCommisionValue(componentId, coverageSelected);

          const tax: CarTax = {
            codigoCobertura: coverageSelected.codigo,
            porcentajeComision,
            porcentajeExtraPrima,
          };

          taxes.push(tax);
        } else {
          let quotationSource: LoadSavedQuotations | LoadQuotationToRenewResponse | undefined;
          
          if (loadSaveQuotationState) {
            quotationSource = savedQuotation as LoadSavedQuotations;
          } else if (renewalQuotationState) {
            quotationSource = quotationToRenewal as LoadQuotationToRenewResponse;
          }

          if (quotationSource) {
            const bien = quotationSource.bienes.find(
              (b) => String(b.numeroComponente) === String(componentId)
            );

            const porcentajeComision = String(quotationSource.formaDePago?.porcentajeComision || 0);
            const porcentajeExtraPrima = String(quotationSource.formaDePago?.porcentajeExtraPrimaVariable || 0);

            bien?.coberturasSeleccionadasAutos?.forEach((coverage) => {
              const tax: CarTax = {
                codigoCobertura: coverage.codigo,
                porcentajeComision,
                porcentajeExtraPrima,
              };

              taxes.push(tax);
            });
          }
        }
      }

      return taxes;
    },
    [getEPVAndCommisionValue, loadSaveQuotationState, savedQuotation, renewalQuotationState, quotationToRenewal, coverageSelectedByVehicle]
  );

  const generateCarReQuotationForm = useCallback(
    (componentId: string): CarReQuotationServiceRequest => {
      
      const form: CarQuotationServiceRequest =
        generateCarQuotationForm(componentId);
      
      const quotationInfo = getQuotationInfoPerVehicle(componentId);
      const bonifications = getBonifications(quotationInfo!);
      const taxes = getTaxes(quotationInfo, componentId);
      
      let codigoTarifa = quotationInfo?.codigoTarifa;
      
      if (!codigoTarifa) {
        let quotationSource: LoadSavedQuotations | LoadQuotationToRenewResponse | undefined;
        
        if (loadSaveQuotationState) {
          quotationSource = savedQuotation as LoadSavedQuotations;
        } else if (renewalQuotationState) {
          quotationSource = quotationToRenewal as LoadQuotationToRenewResponse;
        }

        if (quotationSource) {
          const bien = quotationSource.bienes.find(
            (b) => String(b.numeroComponente) === String(componentId)
          );
          codigoTarifa = bien?.codigoTarifa ? String(bien.codigoTarifa) : undefined;
        }
      }

      const webDiscountFieldName = `webDiscount-tab-${componentId}`;
      const webDiscount = stepTwoForm?.getFieldValue(webDiscountFieldName);
      const descuentoEspecial = webDiscount !== undefined && webDiscount !== null 
        ? String(webDiscount) 
        : "0";

      return {
        ...form,
        codigoTarifa: codigoTarifa!,
        bonificaciones: bonifications,
        impuesto: taxes,
        descuentoEspecial
      };
    },
    [
      generateCarQuotationForm,
      getQuotationInfoPerVehicle,
      getBonifications,
      getTaxes,
      loadSaveQuotationState,
      savedQuotation,
      renewalQuotationState,
      quotationToRenewal,
    ]
  );

  async function getTextSubcategory(coverage: CarQuotationCoverage): Promise<TextSubcategory[] | undefined> {
    try {
      const shouldLoadTextSubcategory = ['S', 'TRUE', '1'].includes(
        String(coverage.tieneTxtSubcategoria).toUpperCase()
      );

      if (!shouldLoadTextSubcategory) {
        return undefined;
      }
      if (quotationInfo?.article &&
        (Object.values(QuotationArticles) as string[]).includes(quotationInfo?.article)) {
        const coverageRiskCode = (coverage as any).codigoRiesgo ?? coverage.coberturaPorDefecto;
        const params: RequestListTextSubcategory = {
          rama: quotationInfo?.branch!,
          cobertura: coverage.codigo,
          moneda: CurrencyCode.PESOS_ARGENTINOS,
          producto: quotationInfo?.groupSelected ?? "",
          riesgo: String(coverageRiskCode ?? '')

        };
        const response = await QuotationService.getListTextSubcategory(params);
        return response.data.subCategoriaDeTextos;
      }
    } catch (error) {

    }

  };

  const executeCarQuotations = useCallback(async () => {
    setCanShowSpinner(true);

    const quotationResponses: Array<{
      componentId: string;
      quotationResponse: CarQuotationServiceResponse;
    }> = [];

    try {
      for (const el of tabs) {
        const form = generateCarQuotationForm(el.key);
        const promiseResponse = await QuotationService.generateCarQuotation(form);
        quotationResponses.push({
          componentId: String(el.key),
          quotationResponse: promiseResponse,
        });
      }

      const quotationResponsesWithTextSubcategory: Array<{
        componentId: string;
        quotationResponse: CarQuotationServiceResponse;
      }> = [];
      for (const { componentId, quotationResponse } of quotationResponses) {
        const coberturas: CarQuotationCoverage[] = [];
        for (const cobertura of quotationResponse?.coberturas ?? []) {
          coberturas.push({
            ...cobertura,
            subCategoriaDeTextos: await getTextSubcategory(cobertura),
          });
        }

        quotationResponsesWithTextSubcategory.push({
          componentId,
          quotationResponse: {
            ...quotationResponse,
            coberturas,
          },
        });
      }

      setQuotationResponseByCar(quotationResponsesWithTextSubcategory);
      setCurrentStep(QuotationStep.THREE);
      scrollToEmitButton();
    } catch (error: any) {
      if (error && error?.errorFields?.length > 0) {
        handleTabErrors(error?.errorFields, ['tab'], 'automóvil');
      }
    } finally {
      setCanShowSpinner(false);
    }
  }, [
    tabs,
    setCanShowSpinner,
    generateCarQuotationForm,
    setQuotationResponseByCar,
    handleTabErrors,
    setCurrentStep,
  ]);

  const executeCarReQuotations = useCallback(async () => {
    setCanShowSpinner(true);

    const reQuotationResponses: Array<{
      componentId: string;
      reQuotationResponse: CarReQuotationServiceResponse;
    }> = [];

    try {
      for (const el of tabs) {
        const form = generateCarReQuotationForm(String(el.key));
        const promiseResponse = await QuotationService.generateCarReQuotation(form);
        reQuotationResponses.push({
          componentId: String(el.key),
          reQuotationResponse: promiseResponse,
        });
      }

      const reQuotationResponsesWithTextSubcategory: Array<{
        componentId: string;
        reQuotationResponse: CarReQuotationServiceResponse;
      }> = [];
      for (const { componentId, reQuotationResponse } of reQuotationResponses) {
        const coberturas: CarQuotationCoverage[] = [];
        for (const cobertura of reQuotationResponse?.coberturas ?? []) {
          coberturas.push({
            ...cobertura,
            subCategoriaDeTextos: await getTextSubcategory(cobertura),
          });
        }

        reQuotationResponsesWithTextSubcategory.push({
          componentId,
          reQuotationResponse: {
            ...reQuotationResponse,
            coberturas,
          },
        });
      }

      setReQuotationResponseByCar(reQuotationResponsesWithTextSubcategory);

      for (const { componentId } of reQuotationResponsesWithTextSubcategory) {
        const coverageSelected = coverageSelectedByVehicle.find(
          (el) => String(el.componentId) === String(componentId)
        )?.coverageSelected;
        if (coverageSelected) {
          await selectCoveragePerVehicle(
            coverageSelected?.codigo!,
            componentId
          );
        }
      }

      if (currentStep === QuotationStep.TWO) {
        setCurrentStep(QuotationStep.THREE);
      }
      setIsErrorServices(false);
      scrollToEmitButton();
      setLabelButton(QUOTATION_BUTTON.EMITIR);
    } catch (error: any) {
      setIsErrorServices(true);
      setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
      if (error && error?.errorFields?.length > 0) {
        handleTabErrors(error?.errorFields, ['tab'], 'automóvil');
      }
      if (loadSaveQuotationState && currentStep === QuotationStep.THREE) {
        setCurrentStep(QuotationStep.TWO);
      }
    } finally {
      setCanShowSpinner(false);
    }
  }, [
    setCanShowSpinner,
    tabs,
    setLabelButton,
    handleTabErrors,
    generateCarReQuotationForm,
    setReQuotationResponseByCar,
    currentStep,
    setCurrentStep,
    coverageSelectedByVehicle,
    selectCoveragePerVehicle,
    loadSaveQuotationState,
  ]);

  const getVersionSelectedByVehicle = useCallback(
    (componentId: string): Version | undefined =>
      versionSelectedByVehicle.find((el) => el.componentId === componentId)
        ?.versionSelected,
    [versionSelectedByVehicle]
  );

  const removeVehicleInfo = useCallback(
    async (componentId: string) => {
      const vehicleInfoIsSaved =
        quotationResponseByCar.some((el) => el.componentId === componentId) ||
        reQuotationResponseByCar.some((el) => el.componentId === componentId);

      try {
        if (vehicleInfoIsSaved) {
          const params: RemoveVehicleDataServiceRequest = {
            token: quotationInfo?.token!,
            rama: quotationInfo?.branch!,
            arse: quotationInfo?.arse!,
            componente: componentId,
          };

          await QuotationService.removeVehicleData(params);

          removeInfoOfVehicle(componentId);
        }
      } catch {}
    },
    [
      quotationResponseByCar,
      reQuotationResponseByCar,
      quotationInfo,
      removeInfoOfVehicle,
    ]
  );

  const callStepTwoServices = useCallback(async () => {
    try {
      setLoadSaveQuotationState(STEP_TWO_SERVICES_LOADING);

      const { tieneScoring, bienes } = savedQuotation as LoadSavedQuotations;

      const promises: Array<Promise<void>> = [];

      if (tieneScoring === DECISION_TYPE.YES)
        promises.push(getScoringQuestions());

      bienes.forEach(({ anio, codigoMarca, codigoModelo }) => {
        promises.push(getBrandsByYear(String(anio!)));
        promises.push(
          getModelByBrandAndYear(String(anio)!, String(codigoMarca)!)
        );
        promises.push(
          getVersionByYearBrandAndModel(
            String(anio)!,
            String(codigoMarca!),
            String(codigoModelo)!
          )
        );
      });

      await Promise.all(promises).then(() =>
        setLoadSaveQuotationState(STEP_TWO_SERVICES_LOADED)
      );
    } catch {}
  }, [savedQuotation, setLoadSaveQuotationState]);

  const callStepTwoServicesForRenew = useCallback(async () => {
    try {
      setRenewalQuotationState(STEP_TWO_SERVICES_LOADING_RENEWAL);

      const { bienes, tieneScoring } = quotationToRenewal as LoadQuotationToRenewResponse;            
      const promises: Array<Promise<void>> = [];

      if (tieneScoring === DECISION_TYPE.YES)
        promises.push(getScoringQuestions());

      bienes.forEach(({ anio, codigoMarca, codigoModelo }) => {
        promises.push(getBrandsByYear(String(anio!)));
        promises.push(
          getModelByBrandAndYear(String(anio)!, String(codigoMarca)!)
        );
        promises.push(
          getVersionByYearBrandAndModel(
            String(anio)!,
            String(codigoMarca!),
            String(codigoModelo)!
          )
        );
      });

      await Promise.all(promises).then(() =>
        setRenewalQuotationState(STEP_TWO_SERVICES_LOADED_RENEWAL)
      );
    } catch(error) {      
    }
  }, [quotationToRenewal, setRenewalQuotationState]);

  const fillStepTwo = useCallback(() => {
    
    setLoadSaveQuotationState(STEP_TWO_DATA_FILLING);

    const { bienes, tieneScoring, cliente } = savedQuotation as LoadSavedQuotations;

    const accessories: { [key: string]: Array<CarAccessoryTable> } = {};
    const tabs: Array<any> = [];

    bienes.forEach(
      ({
        accesorios = [],
        anio,
        buenResultado,
        porcentajeBuenResultado,
        codigoMarca,
        codigoModelo,
        codigoPostal,
        codigoSubModelo,
        descuentoWeb,
        esClienteIntegral,
        numeroComponente,
        origen,
        preguntasScoring = [],
        provincia,
        sufijoPostal,
        tieneDescuentoWeb,
        tieneGnc,
        tipoVehiculo,
        valorDelGnc,
        valorInfoAuto,
        zona,
        chasis,
        motor,
        matricula,
        descripcionUso,
      }) => {
        tabs.push({
          label: <HeaderTabCar id={Number(numeroComponente)} />,
          children: <TabsPropertyDataCar id={Number(numeroComponente)} />,
          key: numeroComponente,
          closable: false,
          forceRender: true,
        });

        newTabIndex.current = Number(numeroComponente);

        const yearFieldName = `vehicleYear-tab-${numeroComponente}`;

        const brandFieldName = `brand-tab-${numeroComponente}`;

        const modelFieldName = `model-tab-${numeroComponente}`;

        const versionFieldName = `version-tab-${numeroComponente}`;

        const gncRadioFieldName = `gnc-tab-${numeroComponente}`;

        if (tieneGnc === DECISION_TYPE.YES) {
          const gncValueFieldName = `gncValue-tab-${numeroComponente}`;
          stepTwoForm.setFieldValue(gncValueFieldName, valorDelGnc);
        }

        const infoValueFieldName = `infoValueCar-tab-${numeroComponente}`;

        const vehicleTypeFieldName = `vehicleType-tab-${numeroComponente}`;

        const originFieldName = `origin-tab-${numeroComponente}`;

        const provinceFieldName = `province-tab-${numeroComponente}`;

        const locationFieldName = `location-tab-${numeroComponente}`;

        const zoneFieldName = `zone-tab-${numeroComponente}`;

        const isIntegralClientFieldName = `integralClient-tab-${numeroComponente}`;

        if (tieneDescuentoWeb === DECISION_TYPE.YES) {
          const discountWebFieldName = `webDiscount-tab-${numeroComponente}`;
          stepTwoForm.setFieldValue(discountWebFieldName, descuentoWeb);
        }

        const goodResultFieldName = `goodResult-tab-${numeroComponente}`;

        const chassisNumberFieldName = `chassisNumber-tab-${numeroComponente}`;
        const engineNumberFieldName = `engineNumber-tab-${numeroComponente}`;
        const patentFieldName = `patent-tab-${numeroComponente}`;
        const useFieldName = `use-tab-${numeroComponente}`;
        const driverNameFieldName = `driver-tab-${numeroComponente}`;

        accessories[numeroComponente] = accesorios.map(
          ({ codigo, precio }) => ({
            key: codigo,
            price: precio,
            accessoryDescription: codigo,
          })
        );

        if (tieneScoring === DECISION_TYPE.YES) {
          preguntasScoring.forEach(({ codigo, respuesta }) => {
            const questionFieldName = `${codigo}-tab-${numeroComponente}`;
            stepTwoForm.setFieldValue(questionFieldName, respuesta);
          });
        }

        stepTwoForm.setFields([
          { name: yearFieldName, value: anio },
          { name: brandFieldName, value: String(codigoMarca) },
          { name: modelFieldName, value: String(codigoModelo) },
          { name: versionFieldName, value: String(codigoSubModelo) },
          { name: gncRadioFieldName, value: tieneGnc },
          { name: infoValueFieldName, value: valorInfoAuto },
          { name: vehicleTypeFieldName, value: tipoVehiculo },
          { name: originFieldName, value: origen },
          { name: provinceFieldName, value: provincia },
          { name: locationFieldName, value: `${sufijoPostal}${codigoPostal}` },
          { name: zoneFieldName, value: zona },
          { name: isIntegralClientFieldName, value: esClienteIntegral },
          { name: goodResultFieldName, value: buenResultado ?? porcentajeBuenResultado },
          { name: chassisNumberFieldName, value: chasis },
          { name: engineNumberFieldName, value: motor },
          { name: patentFieldName, value: matricula },
          { name: useFieldName, value: descripcionUso },
          { name: driverNameFieldName, value: cliente?.nombreCompleto },
        ]);
      }
    );


    setTabs(tabs);

    setActiveKey(tabs[0].key);

    setAccessoryTable(accessories);

    setLoadSaveQuotationState(STEP_TWO_DATA_FILLED);

    setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
  }, [
    setLoadSaveQuotationState,
    savedQuotation,
    setAccessoryTable,
    setTabs,
    setActiveKey,
    setLabelButton,
    stepTwoForm,
    newTabIndex,
  ]);

  const fillStepTwoAsRenewal = useCallback(() => {    
    setRenewalQuotationState(STEP_TWO_DATA_FILLING_RENEWAL);

    const { bienes, tieneScoring, cliente } = quotationToRenewal as LoadQuotationToRenewResponse;
    
    const accessories: { [key: string]: Array<CarAccessoryTable> } = {};
    const tabs: Array<any> = [];

    bienes.forEach(
      ({
        accesorios = [],
        anio,
        buenResultado,
        porcentajeBuenResultado,
        codigoMarca,
        codigoModelo,
        codigoPostal,
        codigoSubModelo,
        descuentoWeb,
        esClienteIntegral,
        numeroComponente,
        origen,
        preguntasScoring = [],
        provincia,
        sufijoPostal,
        tieneDescuentoWeb,
        tieneGnc,
        tipoVehiculo,
        valorDelGnc,
        valorInfoAuto,
        zona,
        chasis,
        motor,
        matricula,
        descripcionUso,
      }) => {
        tabs.push({
          label: <HeaderTabCar id={Number(numeroComponente)} />,
          children: <TabsPropertyDataCar id={Number(numeroComponente)} />,
          key: numeroComponente,
          closable: false,
          forceRender: true,
        });

        newTabIndex.current = Number(numeroComponente);

        const yearFieldName = `vehicleYear-tab-${numeroComponente}`;

        const brandFieldName = `brand-tab-${numeroComponente}`;

        const modelFieldName = `model-tab-${numeroComponente}`;

        const versionFieldName = `version-tab-${numeroComponente}`;

        const gncRadioFieldName = `gnc-tab-${numeroComponente}`;

        if (tieneGnc === DECISION_TYPE.YES) {
          const gncValueFieldName = `gncValue-tab-${numeroComponente}`;
          stepTwoForm.setFieldValue(gncValueFieldName, valorDelGnc);
        }

        const infoValueFieldName = `infoValueCar-tab-${numeroComponente}`;

        const vehicleTypeFieldName = `vehicleType-tab-${numeroComponente}`;

        const originFieldName = `origin-tab-${numeroComponente}`;

        const provinceFieldName = `province-tab-${numeroComponente}`;

        const locationFieldName = `location-tab-${numeroComponente}`;

        const zoneFieldName = `zone-tab-${numeroComponente}`;

        const isIntegralClientFieldName = `integralClient-tab-${numeroComponente}`;

        if (tieneDescuentoWeb === DECISION_TYPE.YES) {
          const discountWebFieldName = `webDiscount-tab-${numeroComponente}`;
          stepTwoForm.setFieldValue(discountWebFieldName, descuentoWeb);
        }

        const goodResultFieldName = `goodResult-tab-${numeroComponente}`;

        const chassisNumberFieldName = `chassisNumber-tab-${numeroComponente}`;
        const engineNumberFieldName = `engineNumber-tab-${numeroComponente}`;
        const patentFieldName = `patent-tab-${numeroComponente}`;
        const useFieldName = `use-tab-${numeroComponente}`;
        const driverNameFieldName = `driver-tab-${numeroComponente}`;
        
        accessories[numeroComponente] = accesorios.map(
          ({ codigo, precio }) => ({
            key: codigo,
            price: precio,
            accessoryDescription: codigo,
          })
        );

        if (tieneScoring === DECISION_TYPE.YES) {
          preguntasScoring.forEach(({ codigo, respuesta }) => {
            const questionFieldName = `${codigo}-tab-${numeroComponente}`;
            stepTwoForm.setFieldValue(questionFieldName, respuesta);
          });
        }

        stepTwoForm.setFields([
          { name: yearFieldName, value: anio },
          { name: brandFieldName, value: String(codigoMarca) },
          { name: modelFieldName, value: String(codigoModelo) },
          { name: versionFieldName, value: String(codigoSubModelo) },
          { name: gncRadioFieldName, value: tieneGnc },
          { name: infoValueFieldName, value: valorInfoAuto },
          { name: vehicleTypeFieldName, value: tipoVehiculo },
          { name: originFieldName, value: origen },
          { name: provinceFieldName, value: provincia },
          { name: locationFieldName, value: `${sufijoPostal}${codigoPostal}` },
          { name: zoneFieldName, value: zona },
          { name: isIntegralClientFieldName, value: esClienteIntegral },
          { name: goodResultFieldName, value: buenResultado ?? porcentajeBuenResultado },
          { name: chassisNumberFieldName, value: chasis },
          { name: engineNumberFieldName, value: motor },
          { name: patentFieldName, value: matricula },
          { name: useFieldName, value: descripcionUso },
          { name: driverNameFieldName, value: cliente?.nombreCompleto },
        ]);
      }
    );


    setTabs(tabs);

    setActiveKey(tabs[0].key);

    setAccessoryTable(accessories);

    setRenewalQuotationState(STEP_TWO_DATA_FILLED_RENEWAL);

    setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    
  }, [
    setRenewalQuotationState,
    quotationToRenewal,
    setAccessoryTable,
    setTabs,
    setActiveKey,
    setLabelButton,
    stepTwoForm,
    newTabIndex,
  ]);

  useEffect(() => {
    if (loadSaveQuotationState === STEP_ONE_DATA_FILLED) {
      callStepTwoServices();
    }
  }, [loadSaveQuotationState]);

  useEffect(() => {
    if (loadSaveQuotationState === STEP_TWO_SERVICES_LOADED) {
      fillStepTwo();
    }
  }, [loadSaveQuotationState]);

  //misma logica para renovar

  useEffect(() => {
    
    if (renewalQuotationState === STEP_ONE_DATA_FILLED_RENEWAL) {
        callStepTwoServicesForRenew();
    }
  }, [renewalQuotationState]);

  useEffect(() => {
    if (renewalQuotationState === STEP_TWO_SERVICES_LOADED_RENEWAL) {
      fillStepTwoAsRenewal();
    }
  }, [renewalQuotationState]);

  useEffect(() => {
    getInitialInfo();
    /* eslint-disable-next-line */
  }, []);

  const values = useMemo(
    () => ({
      accessoriesList,
      accessoryTable,
      showWebDiscountRate,
      activeKey,
      addNewTab,
      duplicateTab,
      getModelByBrandAndYear,
      getVersionByYearBrandAndModel,
      isLoadingAccessoriesList,
      isLoadingModelList,
      isLoadingVersionList,
      keyTabToDelete,
      removeTab,
      setAccessoryTable,
      setActiveKey,
      setKeyTabToDelete,
      setShowModal,
      showModal,
      tabs,
      yearList,
      carFormValues,
      setCarFormValues,
      getBrandsByYear,
      isLoadingBrandList,
      brandsByYear,
      modelsByBrandAndYear,
      versionsByYearBrandAndModel,
      scoringQuestions,
      generateTitleForTabs,
      goodResultTypesList,
      generateCarQuotationForm,
      generateCarReQuotationForm,
      executeCarQuotations,
      labelButton,
      setLabelButton,
      executeCarReQuotations,
      getEPVAndCommisionValue,
      getVersionSelectedByVehicle,
      removeVehicleInfo,
    }),
    [
      accessoriesList,
      accessoryTable,
      showWebDiscountRate,
      activeKey,
      addNewTab,
      duplicateTab,
      getModelByBrandAndYear,
      getVersionByYearBrandAndModel,
      isLoadingAccessoriesList,
      isLoadingModelList,
      isLoadingVersionList,
      keyTabToDelete,
      removeTab,
      setAccessoryTable,
      setActiveKey,
      setKeyTabToDelete,
      setShowModal,
      showModal,
      tabs,
      yearList,
      carFormValues,
      setCarFormValues,
      getBrandsByYear,
      isLoadingBrandList,
      brandsByYear,
      modelsByBrandAndYear,
      versionsByYearBrandAndModel,
      scoringQuestions,
      generateTitleForTabs,
      goodResultTypesList,
      generateCarQuotationForm,
      generateCarReQuotationForm,
      executeCarQuotations,
      labelButton,
      setLabelButton,
      executeCarReQuotations,
      getEPVAndCommisionValue,
      getVersionSelectedByVehicle,
      removeVehicleInfo,
    ]
  );

  return (
    <StepTwoFormContext.Provider value={values}>
      {children}
    </StepTwoFormContext.Provider>
  );
};